/**
 * Component   : UserManagement
 * Description : Adding a new User
 */
import { Card, CardContent, CardHeader, Divider, Grid, Paper, Typography } from "@mui/material";
import { TreeViewBaseItem } from '@mui/x-tree-view/models';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { bindDropDown, callAPI, clearRequest, customValidation, EPhone, formatPhoneNumber, handleApiError, Method, updateMainHeader, validations } from "../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../Components/AutoComplete/AutoComplete";
import { HeaderList, IHeaderListActions } from "../../Components/Header/HeaderList";
import WSPhone from "../../Components/Phone/WSPhone";
import { IPermission } from "../../Components/Roles/WSTreeView";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import clientConfig from '../../Config/clientConfig.json';
import WSTreeViewField from "../../Components/Roles/TreeView";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import WSSelectField from "../../Components/Select/WSSelect";
export const UserManagement: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, watch, reset, getValues } = useForm();
    const navigate = useNavigate();
    const params = useParams();
    const [userRoles, setUserRoles] = useState<any>([]);
    const [userPermissions, setUserPermissions] = useState<any>([]);
    const [permissions, setPermissions] = useState<any>([]);
    const [branchList, setBranchLiist] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const id = params?.id;
    useEffect(() => {
        updateMainHeader("Add User");
        breadCrumbsStore.updateBreadCrumbs([
            { "Users": "/user/list" },
            { [id ? 'Edit User' : "Create User"]: `` },
        ]);
    });
    useEffect(() => () => {
        reset()
    }, [])
    useEffect(() => {
        /**
         * Method to get the user record by id for edit purpose
         * @param id 
         */
        async function getDefaultRole(): Promise<void> {
            try {
                const response: any = await bindDropDown('user-roles/all', 'roleName', 'id', Method.GET);
                setUserRoles(response || [])
            } catch (error) {
                showMessage('Error fetching Role:', 'error');
            }
        }
        async function getBranch(): Promise<void> {
            try {
                const response: any = await bindDropDown('Branch', 'name', 'id', Method.GET) //await callAPI('Branch', Method.GET);
                setBranchLiist(response || [])
            } catch (error) {
                showMessage('Error fetching Branch:', 'error');
            }
        }
        getDefaultRole();
        getBranch();

    }, []);
    async function getRole(roleId: string): Promise<void> {
        try {
            const response: any = await callAPI('user-roles/get-role-permissions', Method.GET, null, roleId);
            setUserPermissions(response?.permissions || [])
        } catch (error) {
            showMessage('Error fetching Role:', 'error');
        }
    }
    useEffect(() => {
        /**
         * Method to get the user record by id for edit purpose
         * @param id 
         */
        async function getUserById(id: any): Promise<void> {
            try {
                const response: any = await callAPI('auth', Method.GET, {}, id);

                if (response && response.data) {
                    if (response.data.permissions) {
                        setUserPermissions(response.data.permissions)
                    }
                    for (const field in response.data) {
                        if (field === 'userName' || field === 'phoneNumber') {
                            setValue(field, formatPhoneNumber((response?.data as any)[field], EPhone.AddHyphen))
                        }
                        else {
                            setValue(field, (response?.data as any)[field]);
                        }
                    }
                }
            } catch (error) {
                showMessage('Error fetching user:', 'error');
            }
        }
        getUserById(id);
    }, [id]);

    const handleCancelClick = () => {
        navigate("/user/list");
    };
    const handleRoleChange = async (evt: any, value: any) => {
        const roleId = value?.value;
        if (roleId) {
            const permissions: any = await getRole(roleId);
        }
        else {
            setUserPermissions([])
        }

    }
    /**
     * Method for Add/Update the data
     * @param data 
     */
    const onSubmit = async (data: any) => {
        try {
            setLoading(true)
            const request: any = await setRequest(data);

            if (id) {
                const response: any = await callAPI(`auth`, Method.PUT, request, id);
                if (response?.errors) {
                    const mess = handleApiError(response)
                    showMessage(mess, 'error');
                }
                else if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/user/list");
                }
            } else {
                const response: any = await callAPI('/auth/register', Method.POST, request);
                if (response?.errors) {
                    const mess = handleApiError(response)
                    showMessage(mess, 'error');
                }
                else if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/user/list");
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        }
        finally {
            setLoading(false)
        }
    };

    /**
     * Method to set the request for the user
     * @param data 
     * @returns 
     */
    async function setRequest(data: any) {
        let request: any = {
            firstName: data?.firstName,
            lastName: data?.lastName,
            email: data?.email,
            pin: data?.pin || "",
            password: data?.password,// encryptedPassword,
            roleId: data?.roleId,
            phoneNumber: formatPhoneNumber(data?.phoneNumber, EPhone.RemoveHyphen) || "",
            permissions: permissions?.length > 0 ? permissions : userPermissions || [],
            pincode: Number(data?.pincode),
            roleType: data?.roleType,
            branchId: data?.branchId
        };
        return clearRequest(request);
    }
    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', size: 'small', loading: loading, buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]

    const handleChangeDaa = (data: any) => {
        setPermissions(data);
    }
    return (

        <>   <form onSubmit={handleSubmit(onSubmit)}>
            <HeaderList title={!id ? "Add User" : "Update User"} isBackButton={true} url="/user/list" type="card" actions={actions} isDivider headerSx={{ height: 50 }} />
            <Paper elevation={3} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, border: '1px solid #ccc', borderRadius: '8px' }}>


                <Grid xs={12} className="modal-input" container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item sm={12} xs={12}>
                        <Typography sx={{ fontSize: '.9rem' }} color={'gray'}>User Information</Typography>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="firstName" {...register('firstName')} name="firstName" rules={{ required: true }} label="First Name *"></WSTextField>

                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="lastName" {...register('lastName')} name="lastName" rules={{ required: true }} label="Last Name "></WSTextField>
                    </Grid>

                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="email" {...register('email')} name="email" rules={customValidation(true, validations.email)} label="Email *"></WSTextField>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="pin" {...register('pin')} rules={{ required: id ? false : false }} minLength={6} maxLength={6} type={TextType.AllowOnlyNumber} name="pin" label="PIN" disabled={id ? true : false}></WSTextField>
                    </Grid>
                    {!id && <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="password"  {...register("password", {
                            required: id ? false : true,
                            validate: (value: any) => {
                                const password = watch("confirmPassword");
                                return value === password || "Passwords do not match";
                            },
                        })} name="password" label="Password *" type={TextType.Password}></WSTextField>
                    </Grid>}


                    {!id && <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="confirmPassword" {...register("confirmPassword", {
                            required: id ? false : true,
                            validate: (value: any) => {
                                const password = watch("password");
                                return value === password || "Passwords do not match";
                            },
                        })} name="confirmPassword" label="Confirm Password *" type={TextType.Password}></WSTextField>
                    </Grid>}

                    <Grid item sm={6} xs={12}>
                        <WSPhone label="Phone" rules={{ required: false }} control={control} id="phoneNumber" {...register('phoneNumber')} name="phoneNumber"></WSPhone>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="pincode" {...register('pincode')} rules={{ required: true }} minLength={6} maxLength={6} type={TextType.AllowOnlyNumber} name="pincode" label="Pin Code" disabled={id ? true : false}></WSTextField>
                    </Grid>

                    <Grid item sm={4} xs={12}>
                        <WSSelectField rules={{ required: true }} control={control} id="branchId" {...register('branchId')} name="branchId" label="Branch *" options={branchList || [{ label: 'Select', value: '0' }]} ></WSSelectField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <WSSelectField rules={{ required: true }} control={control} id="roleType" {...register('roleType')} name="roleType" label="User Type *" options={clientConfig.RoleTypeSourceConfig.staticOptionData} ></WSSelectField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <WSAutocompleteField rules={{ required: true }} control={control} id="roleId" {...register('roleId')} name="roleId" label="Role *" options={userRoles} onChange={handleRoleChange}></WSAutocompleteField>
                    </Grid>
                </Grid>
                <Grid item sm={12} sx={{ marginTop: 2 }}>
                    <Card >
                        <CardHeader title="Permissions" sx={{ fontSize: '0.9rem', color: 'gray', '& .MuiTypography-root': { fontSize: '0.9rem' } }}>

                        </CardHeader>
                        <Divider />
                        <CardContent>
                            {userPermissions && userPermissions.length > 0 && <WSTreeViewField getValues={getValues} setValue={setValue} control={control} onCheckedChange={handleChangeDaa} permissions={userPermissions} />}

                        </CardContent>
                    </Card>
                    {/* <TreeViewField permissions={permissions} onCheckedChange={handleCheckedChange} /> */}
                    {/* <Controller
                        name="selectedItems"
                        control={control}
                        render={({ field }) => (
                            <RichTreeView
                                checkboxSelection
                                items={MUI_X_PRODUCTS}
                                multiSelect={true}

                                selectedItems={field.value}

                                onSelectedItemsChange={handleSelectionChange}
                            />
                        )}
                    /> */}
                </Grid>
                {/* <LocationSearch
                    searchQuery={searchQuery}
                    onSearchChange={setSearchQuery}
                    onSelectLocation={handleSelectLocation}
                />
                {selectedLocation && <p>Selected Location: {selectedLocation}</p>} */}

                {/* <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 1 }}>
                            <WSButton id='submit' label={"Save"} type="submit" size="medium" />
                        </Grid>
                        <Grid item sx={{ marginRight: 2 }}>
                            <WSButton id='cancel' label={"Cancel"} type="button" onClick={handleCancelClick} size="medium" className="ws-cancel" />
                        </Grid>
                    </Grid> */}

            </Paper>
        </form>
        </>
    );
});
